var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgTrash = function SvgTrash(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 7C6.55228 7 7 7.44772 7 8L7 19C7 19.5523 7.44772 20 8 20L16 20C16.5523 20 17 19.5523 17 19L17 8C17 7.44772 17.4477 7 18 7C18.5523 7 19 7.44772 19 8L19 19C19 20.6569 17.6569 22 16 22L8 22C6.34315 22 5 20.6569 5 19L5 8C5 7.44772 5.44772 7 6 7Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 8C10.5523 8 11 8.44772 11 9L11 17C11 17.5523 10.5523 18 10 18C9.44772 18 9 17.5523 9 17L9 9C9 8.44772 9.44772 8 10 8Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 8C14.5523 8 15 8.44772 15 9V17C15 17.5523 14.5523 18 14 18C13.4477 18 13 17.5523 13 17V9C13 8.44772 13.4477 8 14 8Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4 5C4 4.44772 4.44772 4 5 4L19 4C19.5523 4 20 4.44772 20 5C20 5.55228 19.5523 6 19 6L5 6C4.44772 6 4 5.55228 4 5Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8 3C8 2.44772 8.44772 2 9 2L15 2C15.5523 2 16 2.44772 16 3V4L8 4V3Z",
    fill: "black"
  })));
};
export { SvgTrash as ReactComponent };
export default __webpack_public_path__ + "static/media/trash.abad7f02.svg";